import styled from 'styled-components';

export const Inputs = styled.div`
  background: white;
  min-height: 100%;
`
